import { render } from "./gr_teacher.vue?vue&type=template&id=041b50fa"
import script from "./gr_teacher.vue?vue&type=script&lang=js"
export * from "./gr_teacher.vue?vue&type=script&lang=js"

import exportComponent from "D:\\_FEproject\\aplikovanainformatika.sk\\zoneai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__